import { render, staticRenderFns } from "./FailPayment.vue?vue&type=template&id=bdaf7b74&scoped=true&"
import script from "./FailPayment.vue?vue&type=script&lang=js&"
export * from "./FailPayment.vue?vue&type=script&lang=js&"
import style0 from "./FailPayment.vue?vue&type=style&index=0&id=bdaf7b74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaf7b74",
  null
  
)

export default component.exports